import {DatePicker, Radio} from 'antd'
import {baseFieldTypes} from 'apis/base/baseFieldTypes'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback} from 'react'
import {IoCalendarOutline} from 'react-icons/io5'
import {NullAsDefault} from 'views/Shared'
import dayjs from "dayjs";

const MedalFilter = ({
  owner_id,
  owner_type,
  value: filter = {
    active: undefined,
  },
  onChange: setValues = NullAsDefault,
}) => {
  const t = useTranslate()

  const handleChange = useCallback(
    (name, value) => {
      setValues({
        ...filter,
        [name]: value,
      })
    },
    [filter]
  )

  return (
    <div className="flex flex-col md:flex-row items-center gap-2 mt-2">
      <Radio.Group
        name="active"
        buttonStyle="solid"
        className="flex items-center flex-1 justify-end lg:w-auto custom-radio-button"
        onChange={(event) => {
          const { name, value } = event.target
          handleChange(name, value)
        }}
        defaultValue={filter.active || undefined}>
        <Radio.Button value={undefined}>{t('all')}</Radio.Button>
        {baseFieldTypes.active.map(({ value, label }) => (
          <Radio.Button
            key={value}
            value={String(value)}>
            {t(label)}
          </Radio.Button>
        ))}
      </Radio.Group>
    </div>
  )
}

export const MedalAwardFilter = ({
  value: filter = {
    to_date: undefined,
    from_date: undefined,
  },
  onChange: setValues = NullAsDefault,
}) => {
  const t = useTranslate()

  const handleChange = useCallback(
    (name, value) => {
      setValues({
        ...filter,
        [name]: value,
      })
    },
    [filter]
  )

  return (
    <div className="flex flex-col md:flex-row items-center gap-2 mt-2">
      <DatePicker
        allowClear={true}
        suffixIcon={<IoCalendarOutline className="text-color-500"/>}
        onChange={(date, dateString) => {
          handleChange('from_date', dateString)
        }}
        format="YYYY-MM-DD"
        defaultValue={
          filter.from_date ? dayjs(new Date(filter.from_date)) : undefined
        }
        placeholder={t('from date')}
      />
      <DatePicker
        allowClear={true}
        suffixIcon={<IoCalendarOutline className="text-color-500"/>}
        onChange={(date, dateString) => {
          handleChange('to_date', dateString)
        }}
        format="YYYY-MM-DD"
        defaultValue={
          filter.to_date ? dayjs(new Date(filter.to_date)) : undefined
        }
        placeholder={t('to date')}
      />
    </div>
  )
}

export default MedalFilter
